import { FC } from "react"

import { useQueryAttendanceSettings } from "api/reactQuery/queries/teacherAdmin"
import ContentLoader from "components/common/contentLoader"
import ErrorText from "components/common/error/errorText"

import AttendanceForm from "./AttendanceForm"
import AttendanceUpsellView from "./AttendanceUpsellView"

const AdminAttendancePage: FC = () => {
  const { data, isLoading, isError } = useQueryAttendanceSettings()

  if (isLoading && !data) {
    return <ContentLoader data-testid="attendance-settings-loader" />
  }

  if (isError) {
    return <ErrorText />
  }

  if (!data?.data.has_attendance_integration) {
    return <AttendanceUpsellView />
  }

  return (
    <AttendanceForm defaultValue={Number(data?.data.attendance_bonus_amount ?? 0)} />
  )
}

export default AdminAttendancePage
